import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1460,
    xxl: 1800,
    xxxl: Infinity,
  },
})
